import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV } from '../constants/content';
import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const close = () => setOpen(false);

  function handleChat() {
    close();
    openZohoChat();
  }

  return (
    <header className="fm-header">
      <div className="fm-container fm-header__inner">
        <Link to="/" className="fm-logo" onClick={close}>
          <span className="fm-logo__mark" aria-hidden />
          {SITE_NAME}
        </Link>

        <nav className="fm-nav" aria-label="Primary">
          {NAV.map((item) => (
            <Link key={item.href} to={item.href}>
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className="fm-btn fm-btn--primary fm-header__cta"
          onClick={openZohoChat}
        >
          Live chat
        </button>

        <button
          type="button"
          className="fm-menu-btn"
          aria-expanded={open}
          aria-label={open ? 'Close menu' : 'Open menu'}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? '✕' : '☰'}
        </button>
      </div>

      <nav className={`fm-menu${open ? ' is-open' : ''}`} aria-label="Mobile">
        {NAV.map((item) => (
          <Link key={item.href} to={item.href} onClick={close}>
            {item.label}
          </Link>
        ))}
        <button
          type="button"
          className="fm-btn fm-btn--primary"
          onClick={handleChat}
        >
          Live chat
        </button>
      </nav>
    </header>
  );
}
